import { render, staticRenderFns } from "./fillDemoInfo.vue?vue&type=template&id=1b764cb6&scoped=true"
import script from "./fillDemoInfo.vue?vue&type=script&lang=js"
export * from "./fillDemoInfo.vue?vue&type=script&lang=js"
import style0 from "./fillDemoInfo.vue?vue&type=style&index=0&id=1b764cb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b764cb6",
  null
  
)

export default component.exports